import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExternalDocumentFrame } from "@faire/retailer-visitor-shared/components/ExternalDocumentFrame";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { TOSStyleWrapper } from "@faire/retailer-visitor-shared/components/TOSStyleWrapper";
import { getLanguageAndCountrySpecificLink } from "@faire/retailer-visitor-shared/lib/localization";
import { getWindow } from "@faire/web--source/common/getWindow";
import { Column } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
var CopyrightBase = function() {
    // Necessary to prevent flashing wrong copyright
    var _React_useState = _sliced_to_array(React.useState(false), 2), initialized = _React_useState[0], setInitialized = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(undefined), 2), link = _React_useState1[0], setLink = _React_useState1[1];
    React.useEffect(function() {
        var _getWindow_scrollTo, _getWindow;
        var _obj;
        setLink(getLanguageAndCountrySpecificLink((_obj = {}, _define_property(_obj, Language.FRA, [
            {
                countries: [
                    ISO3166Alpha3.CAN
                ],
                link: "https://cdn.faire.com/static/IP+Policy+-+Canada+-+Sept.+15+2022+-+French.pdf"
            }
        ]), _define_property(_obj, Language.SPA, [
            {
                link: "https://cdn.faire.com/static/IP+Policy+-+Spanish.pdf"
            }
        ]), _obj)));
        setInitialized(true);
        (_getWindow_scrollTo = (_getWindow = getWindow()).scrollTo) === null || _getWindow_scrollTo === void 0 ? void 0 : _getWindow_scrollTo.call(_getWindow, 0, 0);
    }, []);
    if (!initialized) {
        return null;
    }
    if (link) {
        return /*#__PURE__*/ _jsx(ExternalDocumentFrame, {
            documentLink: link
        });
    }
    return /*#__PURE__*/ _jsx(TOSStyleWrapper, {
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "7x"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/",
                            children: /*#__PURE__*/ _jsx(FaireLogo, {
                                size: 167
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "copyright",
                    id: "copyright",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "contents",
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "6x"
                            }),
                            /*#__PURE__*/ _jsx(PageHeader, {
                                children: "COPYRIGHT & INTELLECTUAL PROPERTY POLICY"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "4x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: /*#__PURE__*/ _jsx("u", {
                                    children: "Notification of Copyright Infringement:"
                                })
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "Faire Wholesale, Inc. and its subsidiaries (collectively, “",
                                    /*#__PURE__*/ _jsx(Medium, {
                                        children: "Faire"
                                    }),
                                    "”) respect the intellectual property rights of others and expects its users to do the same."
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "It is Faire’s policy, in appropriate circumstances and at its discretion, to disable and/or terminate the accounts of users who repeatedly infringe or are repeatedly charged with infringing the copyrights or other intellectual property rights of others."
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "In accordance with the Digital Millennium Copyright Act of 1998, the text of which may be found on the U.S. Copyright Office website at",
                                    " ",
                                    /*#__PURE__*/ _jsx(Anchor, {
                                        href: "https://www.copyright.gov/legislation/dmca.pdf",
                                        type: "application/pdf",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: "http://www.copyright.gov/legislation/dmca.pdf"
                                    }),
                                    ", Faire will respond expeditiously to claims of copyright infringement committed using the Faire and/or Faire subsidiary or affiliated websites (the “",
                                    /*#__PURE__*/ _jsx(Medium, {
                                        children: "Sites"
                                    }),
                                    "”) that are reported to Faire’s Designated Agent, identified in the sample notice below."
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "If you are a copyright owner, or are authorized to act on behalf of one, or authorized to act under any exclusive right under copyright, please report alleged copyright infringements taking place on or through the Sites by completing the following DMCA Notice of Alleged Infringement and delivering it to Faire’s Designated Agent. Upon receipt of the Notice as described below, Faire will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged material from the Sites."
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("blockquote", {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansMedium",
                                        children: "DMCA Notice of Alleged Infringement (“Notice”)"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("ol", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted works that you claim have been infringed."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Identify the material that you claim is infringing (or to be the subject of infringing activity) and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material, including at a minimum, if applicable, the URL of the link shown on the Site(s) where such material may be found."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your mailing address, telephone number, and, if available, email address."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    "Include both of the following statements in the body of the Notice:",
                                                    /*#__PURE__*/ _jsxs("ul", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: "“I hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use).”"
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: "“I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.”"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your full legal name and your electronic or physical signature."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        children: "Deliver this Notice, with all items completed, to Faire’s Designated Agent:"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        children: [
                                            "Designated Agent",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "c/o Faire Wholesale, Inc.",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "100 Potrero Avenue",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "San Francisco, CA 94103",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx(Anchor, {
                                                href: "mailto:copyrights@faire.com",
                                                rel: "noreferrer",
                                                target: "_blank",
                                                children: "copyrights@faire.com"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: /*#__PURE__*/ _jsx("u", {
                                    children: "Counter Notices:"
                                })
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "One who has posted material that allegedly infringes a copyright may send Faire a counter notice pursuant to Sections 512(g)(2) and 512(g)(3) of the DMCA. When Faire receives a counter notice, Faire will reinstate the material in question in not less than 10 and not more than 14 business days after Faire receives the counter notice unless Faire first receives notice from the copyright claimant that he/she has filed a legal action to restrain the allegedly infringing activity. To provide a counter notice to Faire, please return the following form to Faire’s Designated Agent. Please note that if you provide a counter notice, in accordance with the Faire Privacy Policy located at",
                                    " ",
                                    /*#__PURE__*/ _jsx(Anchor, {
                                        // eslint-disable-next-line @faire/no-absolute-faire-url
                                        href: "https://www.faire.com/privacy",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: "https://www.faire.com/privacy"
                                    }),
                                    " ",
                                    "and the terms of the DMCA, the counter notice will be given to the copyright claimant."
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("blockquote", {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansMedium",
                                        children: "Counter Notice"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("ol", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Identify the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your mailing address, telephone number, and, if available, email address."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsxs("li", {
                                                children: [
                                                    "Include both of the following statements in the body of the Notice:",
                                                    /*#__PURE__*/ _jsxs("ul", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: "“I hereby state under penalty of perjury that I have a good faith belief that the material was removed or disabled as a result of mistake or misidentification of the material to be removed or disabled.”"
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: "“I hereby state that I consent to the jurisdiction of the Federal District Court for the judicial district in which my address is located or, if my address is outside of the United States, for any judicial district in which Faire may be found, and I will accept service of process from the complaining party who notified Faire of the alleged infringement or an agent of such person.”"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your full legal name and your electronic or physical signature."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        children: "Deliver this Notice, with all items completed, to Faire’s Designated Agent:"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        children: [
                                            "Designated Agent",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "c/o Faire Wholesale, Inc.",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "100 Potrero Avenue",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "San Francisco, CA 94103",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx(Anchor, {
                                                href: "mailto:copyrights@faire.com",
                                                rel: "noreferrer",
                                                target: "_blank",
                                                children: "copyrights@faire.com"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: /*#__PURE__*/ _jsx("u", {
                                    children: "Notification of Claimed Trademark Infringement:"
                                })
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "If you are a trademark owner and you believe your trademark (the “",
                                    /*#__PURE__*/ _jsx(Medium, {
                                        children: "Mark"
                                    }),
                                    "”) being used on the Site by a user in a way that constitutes trademark infringement, please note that Faire is not in a position to mediate trademark disputes between users and trademark owners. Because of this, we strongly encourage trademark owners to resolve their disputes directly with the user who posted the content in question."
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "If you are unable to resolve your dispute directly, and you believe that the Mark is being used on the Site by a user in a way that constitutes trademark infringement, please provide Faire’s Designated Agent (specified above) with the following information:"
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("ol", {
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Your full legal name and your electronic or physical signature."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Information reasonably sufficient to permit Faire to contact you or your authorized agent, including a name, mailing address, telephone number and, if available, an email address."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Identification of the Mark(s) alleged to have been infringed, including (i) for registered Marks, a copy of each relevant federal trademark registration certificate or (ii) for common law or other Marks, evidence sufficient to establish your claimed rights in the Mark, including the nature of your use of the Mark, and the time period and geographic area in which the Mark has been used by you."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Information reasonably sufficient to permit Faire to identify the use being challenged."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            "Include both of the following statements in the body of the Notice:",
                                            /*#__PURE__*/ _jsxs("ul", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: "“I hereby state that I have not authorized the challenged use, and I have a good- faith belief that the challenged use is not authorized by law.”"
                                                    }),
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: "“I hereby state under penalty of perjury that all of the information in the notification is accurate and that I am the owner of the Mark, or authorized to act on behalf of the owner of the Mark.”"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "Upon receipt of notification of claimed trademark infringement as described above, Faire will seek to confirm the existence of the Mark on the Sites, notify the registered user who posted the content including the Mark, and will within a reasonable time take action to remove or disable the Mark on the Sites."
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs(Typography, {
                                children: [
                                    "One who has materials removed from the site in response to a notification of claimed trademark infringement will have the right to submit a counter-notification to Faire within 10 business days. When Faire receives a counter-notification, Faire will reinstate the material in question within a reasonable period of time after Faire receives the counter-notification. To provide a counter-notification to Faire, please return the following form to Faire’s Designated Agent. Please note that if you provide a counter-notification, in accordance with the Faire Privacy Policy located at",
                                    " ",
                                    /*#__PURE__*/ _jsx(Anchor, {
                                        // eslint-disable-next-line @faire/no-absolute-faire-url
                                        href: "https://www.faire.com/privacy",
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: "https://www.faire.com/privacy"
                                    }),
                                    " ",
                                    "the counter-notification will be given to the claimant. A counter-notification must contain the following elements:"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("blockquote", {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansMedium",
                                        children: "Counter-Notification"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("ol", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Identify the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your mailing address, telephone number, and, if available, email address."
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Include both of the following statements in the body of the Notice:"
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("ul", {
                                                children: /*#__PURE__*/ _jsx("li", {
                                                    children: "“I hereby state under penalty of perjury that I have a good faith belief that the material was removed or disabled as a result of mistake or misidentification of the material to be removed or disabled.”"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "Provide your full legal name and your electronic or physical signature."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: /*#__PURE__*/ _jsx("u", {
                                    children: "Notification of Other Intellectual Property (“IP”) Infringement:"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "If you believe that some other IP right of yours is being infringed by a user, please provide Faire’s Designated Agent (specified above) with the following information:"
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("ol", {
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Your full legal name and your electronic or physical signature."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Information reasonably sufficient to permit Faire to contact you or your authorized agent, including a name, mailing address, telephone number and, if available, an email address."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Identification of the IP alleged to have been infringed, including (i) a complete description or explanation of the nature of the IP, (ii) evidence that you own the IP in the relevant jurisdiction, including copies of relevant patents, registrations, certifications or other documentary evidence of your ownership, and (iii) a showing sufficient for Faire to determine without unreasonable effort that the IP has been infringed;."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Information reasonably sufficient to permit Faire to identify the use being challenged."
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: "Include both of the following statements in the body of the Notice:"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsxs("ul", {
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "“I hereby state that I have not authorized the challenged use, and I have a good- faith belief that the challenged use is not authorized by law.”"
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: "“I hereby state under penalty of perjury that all of the information in the notification is accurate and that I am the owner of the IP, or authorized to act on behalf of the owner of the IP.”"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                children: "Upon receipt of notice as described above, Faire will seek to confirm the existence of the IP on the Sites, notify the user who posted the content including the IP, and take whatever action, in its sole discretion, it deems appropriate, including temporary or permanent removal of the IP from the Sites."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Footer, {})
            ]
        })
    });
};
var Wrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-9c006bc0-0"
})([
    "align-self:stretch;ol{",
    "}"
], TypographyStyles({
    as: undefined
}));
var PageHeader = styled.h1.withConfig({
    componentId: "sc-9c006bc0-1"
})([
    "",
    ""
], TypographyStyles({
    as: "h5",
    align: "center"
}));
export var Copyright = observer(CopyrightBase);
